import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import {
  AddOutlined,
  SearchOutlined
} from '@mui/icons-material';

import {
  AppBar,
  Box,
  Button,
  IconButton,
  InputBase,
  Toolbar
} from '@mui/material';

import logo from '../../../assets/images/logo_new.png';

import {
  accentLineSx,
  headerActionsSx,
  headerSx,
  logoSx,
  registerButtonSx,
  searchIconSx,
  searchInputSx,
  searchWrapperSx,
  toolbarSx
} from '../../Common/components/Styles/AuthStyles';

const AuthHeader = () => {
  return (
    <>
      <AppBar
        position="relative"
        sx={headerSx}>
        <Toolbar
          disableGutters
          sx={toolbarSx}>
          <RouterLink
            aria-label="Go to home"
            to="/">
            <Box
              alt="EHRZip"
              component="img"
              src={logo}
              sx={logoSx}
            />
          </RouterLink>

          <Box sx={headerActionsSx}>
            <Box sx={searchWrapperSx}>
              <InputBase
                inputProps={{
                  'aria-label': 'Search practice'
                }}
                placeholder="Search practice"
                sx={searchInputSx}
              />

              <IconButton
                aria-label="Search practice"
                sx={searchIconSx}>
                <SearchOutlined />
              </IconButton>
            </Box>

            <Button
              component={RouterLink}
              size="small"
              startIcon={<AddOutlined />}
              sx={registerButtonSx}
              to="/register-practice"
              variant="contained">
              Register Practice
            </Button>
          </Box>
        </Toolbar>
      </AppBar>

      <Box sx={accentLineSx} />
    </>
  );
};

export default AuthHeader;